import CardCrossSell from '../../../../../layouts/Card/cardContent/CardCrossSell';

export const listSettings = {
    grid: {
        components: CardCrossSell,
        columns: {
            xs: 1,
            sm: 2,
            md: 3,
            laptop: 3,
        }
    },
}

export const listMappers = [
    {
        view: 'card',
        mapper: null
    },
    // {
    //     view : 'table',
    //     mapper : 'companiesListMapper'
    // }
]

export const perPageOptions = {
    'card': ['9'],
}